import { DealRequestAllocation } from '../../shared/models';
import { ReactComponent as OtherFinancingNeeds } from '../../shared/icons/OtherFinancingNeeds.svg';
import { DebtCapitalHeading } from './DebtCapitalHeading';
import {
	CerebroComplexListItem,
	CerebroHeading,
	CerebroLabel,
	CerebroStyledBox,
	CerebroText,
} from '../../shared/components';

interface DebtOtherFinancingNeedsProps {
	allocation: DealRequestAllocation;
}

export const DebtOtherFinancingNeeds: React.FC<DebtOtherFinancingNeedsProps> = ({ allocation }) => {
	const isEmpty = isOtherFinancingNeedsEmpty(allocation);

	return (
		<>
			<DebtCapitalHeading icon={OtherFinancingNeeds} amountRequested={allocation.otherFinancingAmount ?? 0}>
				Other Financing Needs
			</DebtCapitalHeading>

			{isEmpty ? (
				<CerebroStyledBox sx={{ marginBottom: 8 }}>
					<CerebroHeading size="h2" component="h2">
						No details have been added yet.
					</CerebroHeading>
					<br />
				</CerebroStyledBox>
			) : (
				<CerebroComplexListItem sx={{ marginTop: 2, marginBottom: 8 }}>
					<CerebroLabel sx={{ marginTop: 1.5, marginBottom: 1.5 }}>
						Description of additional needs
					</CerebroLabel>
					<CerebroText variant="small" sx={{ marginTop: 1.5 }}>
						{allocation.otherFinancingDescription}
					</CerebroText>
				</CerebroComplexListItem>
			)}
		</>
	);
};

export function isOtherFinancingNeedsEmpty(allocation: DealRequestAllocation): boolean {
	return !allocation.otherFinancingAmount;
}
